import { render } from "./GlutenFreeSummary.vue?vue&type=template&id=04e47cd8"
import script from "./GlutenFreeSummary.vue?vue&type=script&lang=js"
export * from "./GlutenFreeSummary.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__